import React from 'react';
import ActionItemListItemAssigned from "./ActionItemListItemAssigned.mjs";

export default function ActionItemListSectionAssigned({heading, action_item_list_section, displayActionItem}) 
{
    if (action_item_list_section.length == 0) return;
    
    var user_icon_file = "./images/person.svg";

    return ( 
        <> 
            <div class="mt-2 mb-1"> 
                <img class="list_item_icon me-1" src={user_icon_file} alt="user" border="0"/><small>{heading} ({action_item_list_section.length})</small>
            </div>
            { action_item_list_section?.map( (ai, i) => ( <ActionItemListItemAssigned action_item={ai} key={i} displayActionItem={displayActionItem} /> )) }
        </> 
    );
}
